import {DataFetcher} from '@aboutyou/data-fetcher';
import {PriceAndBrandSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import React from 'react';
import {RecommendationsSkeleton} from '../../../Basket/Recommendations/Recommendations.skeleton';
import {
  useSimilarProducts,
  useSimilarProductsClientOnly,
} from '../../../SimilarProducts/hooks/useSimilarProducts';
import {usePriceAndBrandSection} from '../../useGetProductBulkSection';
import {SimilarProductsRecoView} from './SimilarProductsRecoView';

export const SimilarProductsReco = ({
  renderingPriority,
}: {
  renderingPriority?: number;
}) => {
  return (
    <DataFetcher
      request={useSimilarProducts()}
      View={SimilarProductsRecoView}
      Error={null}
      Loading={RecommendationsSkeleton}
      renderingPriority={renderingPriority}
    />
  );
};

const SoldOutSimilarProductsRecoFetcher: React.FC<PriceAndBrandSection> = ({
  product,
}) => {
  if (!product?.isSoldOut) return null;
  return (
    <DataFetcher
      // eslint-disable-next-line react-hooks/rules-of-hooks
      request={useSimilarProductsClientOnly()}
      View={SimilarProductsRecoView}
      Error={null}
      Loading={RecommendationsSkeleton}
    />
  );
};

export const SoldOutSimilarProductsReco: React.FC = props => {
  return (
    <DataFetcher
      request={usePriceAndBrandSection()}
      Error={() => null}
      Loading={undefined}
      View={SoldOutSimilarProductsRecoFetcher}
      viewProps={props}
      computeDefaultState={() => undefined}
    />
  );
};
